<template>
  <div class='table_card'>
    <el-dialog :title="dialogTitle" :visible.sync="isShow" width="64%" append-to-body @close="closeWindow">
      <el-form :inline="true" :model="searchForm" size="mini" label-width="120px" class="demo-form-inline">
        <el-form-item label='开始结束时间：'>
          <el-date-picker v-model="timeValue" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
             start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type='primary' icon='el-icon-search' @click='getTableData' style="margin-left:15px;">查询
          </el-button>
        </el-form-item>
      </el-form>
      <!-- 表格盒子 -->
      <el-table :data='tableData' :header-cell-style="{ background: '#f8fafa' }" border highlight-current-row>
        <el-table-column fixed type="index" align="center" label="序号" width="60">
        </el-table-column>
        <el-table-column align='center' prop='reportDate' label='报告产生日期'></el-table-column>
        <el-table-column align='center' prop='respirationScore' label='呼吸分数'></el-table-column>
        <el-table-column align='center' prop='sleepScore' label='睡眠总体分数'></el-table-column>
        <el-table-column align='center' prop='mood' label='心情分数'></el-table-column>
        <el-table-column align='center' prop='heartHp' label='心脏健康分数(0-100)'></el-table-column>
        <el-table-column align='center' prop='sleepTime' label='入睡时间'></el-table-column>
        <el-table-column align='center' prop='sleepDuration' label='睡眠时长(分钟)'></el-table-column>
        <el-table-column align='center' prop='aveBr' label='平均呼吸率'></el-table-column>
        <el-table-column align='center' prop='aveHr' label='平均心率'></el-table-column>
        <el-table-column align='center' label='操作' fixed='right' >
          <template slot-scope='scope'>
            <button class='tabBtn' @click="showDialog('查看', scope.row)">查看</button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination :page-size='pageConfig.pageSize' layout='total, prev, pager, next, jumper'
        @current-change='handleCurrentChange' :total='pageConfig.total'></el-pagination>
        <div class="btn">
      <div class="action-buttons">
        <el-button @click="closeWindow">取 消</el-button>
      </div>
    </div>
    <reportInfo title='报告详情' :isDialog="isDialog" :detailInfo="detailInfo" @closeDialog="closeDialog" v-if="isDialog"></reportInfo>
    </el-dialog>
  </div>
</template>
<script>
import '@/assets/css/system.css'
import { post } from '@/api/requrestHttp'
import reportInfo from './reportInfo.vue';
export default {
  components:{ reportInfo },
  props: ['dialogTitle', 'isShow','customerId'],
  data() {
    return {
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      dialogShow: false,
      detailInfo: {},
      searchForm: {},
      timeValue: '',
      isDialog:false
    }
  },
    watch:{
      isShow: {
        handler(newVal) {
            if (newVal) {
            this.getTableData();
            }
        },
      immediate: true 
    }
    },
  methods: {
    //获取列表数据
    async getTableData() {
      const { content } = await post('/ypt/admin/equipment/sleepReport/findList', {
        reportStartDate: this.timeValue[0],
        reportEndtDate: this.timeValue[1],
        ...this.pageConfig,
         customerId:this.customerId
      })
      if(content !=null){
          this.tableData = content.list || []
         this.pageConfig.total = content.count
      }else{
          this.tableData = []
          this.pageConfig.total = 0
      }
      
    },
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val;
      this.getTableData();
    },
    async showDialog(type, row) {
      this.isDialog = true
      let url='ypt/admin/equipment/sleepReport/getDetailById' //'ypt/admin/equipment/sleepReport/getById'
      let res= await post(url, {id:row.id})  //row.id
      if(res.content){
        this.detailInfo =res.content || {}
      }
    },
    closeDialog() {
      this.detailInfo = {}
      this.isDialog = false
    },
    closeWindow() {
      this.$emit('dialogClose')
    }
  },
  mounted() {
  //  this.getTableData();
  }
}
</script>
<style scoped>
.tabBtn {
  font-size: 13px;
  margin: 0 3px;
}
.action-buttons {
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #eee;
    text-align: right;
}

.cancel-btn {
    margin-right: 10px;
}
</style>